import { cn } from '@/platform/lib/utils';
import { Switch } from '@headlessui/react';

const FilterBarToggle = ({
    label,
    checked = false,
    onChange,
    className,
    ...props
}) => (
    <label
        className={cn(
            'inline-flex cursor-pointer items-center gap-2 px-4 text-sm text-gray-700 select-none',
            className
        )}
    >
        <Switch
            checked={checked}
            onChange={onChange}
            className={cn(
                'relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition',
                checked ? 'bg-primary-600' : 'bg-gray-200'
            )}
            {...props}
        >
            <span
                className={cn(
                    'inline-block size-4 transform rounded-full bg-white shadow transition',
                    checked ? 'translate-x-4' : 'translate-x-0.5'
                )}
            />
        </Switch>
        {label && <span>{label}</span>}
    </label>
);

export default FilterBarToggle;
